import React, { useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import InputEmoji from "react-input-emoji";
import { ReactSession } from 'react-client-session';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import classes from './ReplyForm.module.css'

function ReplyForm(params) {
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);
  const [text, setText] = useState("");
  const [objectId, setObjectId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  ReactSession.setStoreType("localStorage");

  const logged_user = ReactSession.get("logged_user");

  useEffect(() => {
    if(params.type === '1') {
        setObjectId(`video_${params.vid}`);
    }else if(params.type === '2') {
        setObjectId(`image_${params.vid}`);
    }
}, []);

  const onSubmit = () => {
    if(logged_user) {
        setIsLoading(true);
        const toast_id = toast.loading("Please wait...");
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/addcomment.php`, {
            user_id: logged_user,
            object_id: objectId,
            reply_id: params.reply,
            comment_text: text,
            action: 'addcomment'
        },{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            // console.log(res.data);
            // getComments();
            setIsLoading(false);
            toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false, closeOnClick: true, rtl: true});
            setText('');
            setIsActive(false);
        }).catch(err => {
            console.log(err);
        })
    }else {
        if(window.confirm("You must be logged in to comment.")) {
          navigate('/login');
        }
    }
}

  return (
    <div className={classes.reply}>
      <li className={classes.reply_btn} onClick={() => setIsActive(true)}>
        <i className="fa-solid fa-reply"></i> <span>Reply</span>
      </li>
      {
        isActive && <form>
          <InputEmoji
              value={text}
              onChange={setText}
              cleanOnEnter
              onEnter={onSubmit}
              placeholder="Type a message"
              />
          {/* <textarea {...register('register', { required: true })} defaultValue="Share what you think?" className='form-control' rows="3" /> */}
          
          <div className="btn_group text-end">
            <button className='btn btn-light' type="button" onClick={() => setIsActive(false)}>Cancel</button>
            <button className='btn btn-primary' type="button" onClick={() => onSubmit()} disabled={isLoading}>Submit</button>
          </div>
        </form>
      }
    </div>
  )
}

export default ReplyForm